import type { FC, SVGProps } from 'react';
import _camelCase from 'lodash/camelCase';

export type SvgIconComponent = FC<SVGProps<SVGSVGElement>>;

const modules = import.meta.glob('../../../assets/icons/**/*.svg', {
  eager: true,
  import: 'default',
}) as Record<string, SvgIconComponent>;

export const getIcons = (): Record<string, SvgIconComponent> => {
  return Object.keys(modules).reduce(
    (acc: Record<string, SvgIconComponent>, pathKey) => {
      const base = pathKey.split('/').slice(-1)[0] ?? '';
      const iconName = _camelCase(base.replace(/\.svg$/, ''));
      acc[iconName] = modules[pathKey];
      return acc;
    },
    {},
  );
};
